<div
  id="user"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div
    class="header"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayout.gt-sm="row"
    fxLayoutAlign.gt-sm="space-between end">
    <div
      class="name"
      fxLayout="row"
      fxLayoutAlign="center center"
      [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
      <button mat-icon-button [routerLink]="'/users'">
        <mat-icon>arrow_back</mat-icon>
      </button>
      {{ selectedUser.firstName }} {{ selectedUser.lastName }}
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content" fxLayout="row wrap">
    <!-- CONTENT CARD -->
    <div class="content-card" fxFill>
      @if (isLoading) {
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
          class="mat-progress-bar"></mat-progress-bar>
      }
      <!-- CONTENT -->
      @if (!isLoading) {
        <div class="content">
          <mat-tab-group
            [selectedIndex]="selectedTab"
            fxLayout="column"
            mat-stretch-tabs="false"
            mat-align-tabs="start"
            fxLayout="column"
            fxFlex
            fxFill>
            <mat-tab label="{{ 'USERS.SINGLE.TABS1.TITLE' | translate }} ">
              <div class="content" fxLayout="row wrap">
                <div
                  fxLayout="column"
                  fxFlex="30"
                  fxFlex.md="30"
                  fxFlex.sm="50"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="mat-card profile-card">
                    <h2 class="card-title">
                      {{ 'USERS.SINGLE.TABS1.BASICINFO' | translate }}
                    </h2>
                    @if (checkPermission() && !isUploadImageDisabled) {
                      <div
                        class="profile-picture"
                        id="clickable"
                        fxLayoutAlign="center center">
                        <img
                          class="profile-image"
                          [src]="
                            selectedFileUrl
                              ? selectedFileUrl
                              : 'assets/images/avatars/avatar.png'
                          "
                          [@animate]="{
                            value: '*',
                            params: { delay: '50ms', scale: '1' },
                          }"
                          alt="Avatar du profil" />
                        @if (
                          this.selectedFileUrl !== null && checkPermission()
                        ) {
                          <div class="icons">
                            @if (this.selectedFileUrl !== null) {
                              <button
                                class="icon-button"
                                (click)="openDialog()">
                                <mat-icon class="custom-icon">edit</mat-icon>
                              </button>
                            }
                            @if (this.selectedFileUrl !== null) {
                              <button
                                class="icon-button"
                                style="color: #f44336"
                                (click)="openDialogDelete()">
                                <mat-icon class="custom-icon">delete</mat-icon>
                              </button>
                            }
                            @if (
                              this.selectedFileUrl === null && checkPermission()
                            ) {
                              <mat-icon class="custom-icon"
                                >add_circle_outline</mat-icon
                              >
                            }
                          </div>
                        }
                        @if (
                          this.selectedFileUrl === null && checkPermission()
                        ) {
                          <div class="icons">
                            @if (this.selectedFileUrl === null) {
                              <button
                                class="icon-button"
                                (click)="openDialog()">
                                @if (
                                  this.selectedFileUrl === null &&
                                  checkPermission()
                                ) {
                                  <mat-icon class="custom-icon"
                                    >add_circle_outline</mat-icon
                                  >
                                }
                              </button>
                            }
                          </div>
                        }
                      </div>
                    } @else {
                      <div
                        class="profile-picture"
                        fxLayoutAlign="center center">
                        <img
                          class="profile-image"
                          [src]="
                            selectedFileUrl
                              ? selectedFileUrl
                              : 'assets/images/avatars/avatar.png'
                          "
                          [@animate]="{
                            value: '*',
                            params: { delay: '50ms', scale: '1' },
                          }"
                          alt="Avatar du profil" />
                      </div>
                    }
                    @if (isUploadImageDisabled) {
                      <div class="message-box warning">
                        {{
                          'USERS.SINGLE.TABS3.MAINTENANCE-PICTURE' | translate
                        }}
                      </div>
                    }
                    <div fxLayoutAlign="center center" class="profile-name">
                      {{ selectedUser.firstName }} {{ selectedUser.lastName }}
                    </div>
                    <div fxLayoutAlign="center center" class="profile-username">
                      ({{ selectedUser.username }})
                    </div>
                    <mat-list role="list">
                      <mat-list-item>
                        <mat-icon matListItemIcon>cake</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{ selectedUser.dateOfBirth }}
                        </h4>
                      </mat-list-item>
                      @if (selectedUser?.avsAlign === true) {
                        <mat-list-item>
                          <mat-icon matListItemIcon>person</mat-icon>
                          <h4 matListItemTitle class="nobreak">
                            {{ selectedUser.gender }}
                          </h4>
                        </mat-list-item>
                      }
                      <mat-list-item>
                        <mat-icon matListItemIcon>language</mat-icon>
                        <h4 matListItemTitle class="nobreak">
                          {{
                            selectedUser.preferredLanguage | transformLanguage
                          }}
                        </h4>
                      </mat-list-item>
                    </mat-list>
                    @if (selectedUser.avsAlign === false) {
                      <div class="message-box warning">
                        {{
                          'USERS.SINGLE.TABS3.AVS_MISALIGNED-TEXT' | translate
                        }}
                        <br />
                        <b>
                          {{
                            'USERS.SINGLE.TABS3.AVS_MISALIGNED-TEXT1'
                              | translate
                          }}
                        </b>
                        {{ selectedUser.firstName }} {{ selectedUser.lastName }}
                        <b>
                          <br />
                          {{
                            'USERS.SINGLE.TABS3.AVS_MISALIGNED-TEXT2'
                              | translate
                          }}
                        </b>
                        {{ selectedUser.misalignedFirstname }}
                        {{ selectedUser.misalignedName }}
                      </div>
                    }
                  </mat-card>
                </div>
                <div
                  ffxLayout="column"
                  fxFlex="70"
                  fxFlex.md="70"
                  fxFlex.sm="50"
                  fxFlex.xs="100"
                  fxLayout="column">
                  <mat-card class="security-card">
                    <h2>{{ 'USERS.SINGLE.TABS3.SUBTITLE' | translate }}</h2>
                    @if (isErrorGetUsers === false) {
                      @if (selectedUser.lifeCycleState === 'active') {
                        <div class="message-box warning">
                          {{ 'USERS.SINGLE.TABS3.DESCRIPTION' | translate }}
                        </div>
                      }
                      @if (selectedUser.lifeCycleState !== 'active') {
                        <div class="message-box alert">
                          {{ 'USERS.SINGLE.TABS3.NOTACTIVATED' | translate }}
                        </div>
                      }
                    }
                    @if (selectedUser.lifeCycleState === 'active') {
                      @if (
                        lastPasswordModification$ | async;
                        as lastModificationDate
                      ) {
                        @if (lastModificationDate) {
                          <div class="message-box warning">
                            {{ 'USER.LAST-UPDATE' | translate }}
                            {{
                              lastModificationDate | date: 'dd.MM.yyyy, hh:mm'
                            }}
                          </div>
                        }
                      }
                      <br />
                      <form fxLayout="column" [formGroup]="securityform">
                        <div fxFlex="1 0 auto" fxLayout="column">
                          <div fxFlex="2 0 auto" fxLayout="column">
                            <mat-form-field
                              appearance="outline"
                              class="field-container">
                              <mat-label>{{
                                'SECURITY.PASSWORD.TITLE' | translate
                              }}</mat-label>

                              <app-pass-visibility
                                #toggleNew
                                matSuffix></app-pass-visibility>
                              <input
                                autoComplete="on"
                                matInput
                                formControlName="password"
                                required
                                [type]="toggleNew.type"
                                placeholder="Password"
                                [formControl]="
                                  securityform.get('password') | formPipe
                                " />
                              @if (securityform.get('password').invalid) {
                                <mat-error>
                                  {{ getErrorMessage() }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                          <div fxFlex="2 0 auto" fxLayout="column">
                            <mat-form-field
                              appearance="outline"
                              class="field-container">
                              <mat-label>{{
                                'SECURITY.PASSWORDCONFIRMATION.TITLE'
                                  | translate
                              }}</mat-label>
                              <app-pass-visibility
                                #toggleConfirm
                                matSuffix></app-pass-visibility>
                              <input
                                autoComplete="on"
                                matInput
                                formControlName="passwordConfirmation"
                                required
                                [type]="toggleConfirm.type"
                                placeholder=""
                                [formControl]="
                                  securityform.get('passwordConfirmation')
                                    | formPipe
                                " />
                            </mat-form-field>
                          </div>
                          @if (securityform.hasError('passwordNotMatch')) {
                            <div class="error-container">
                              @if (securityform.hasError('passwordNotMatch')) {
                                <mat-error class="message-box error">
                                  {{ 'ERROR.IDENTICALPSWD' | translate }}
                                </mat-error>
                              }
                            </div>
                          }
                          <mat-checkbox
                            [formControl]="
                              securityform.get('mustChangePwd') | formPipe
                            ">
                            {{
                              'SECURITY.FORM.CHECK' | translate
                            }}</mat-checkbox
                          >
                        </div>
                        <div
                          class="general-container"
                          fxLayout="row"
                          fxLayoutAlign="left center">
                          <button
                            mat-raised-button
                            type="button"
                            color="accent"
                            (click)="changePwd()"
                            [disabled]="
                              securityform.invalid ||
                              isBusy ||
                              isPasswordChangeDisabled
                            ">
                            {{ 'GENERAL.SAVE' | translate }}
                          </button>
                        </div>
                        @if (isPasswordChangeDisabled) {
                          <div class="message-box warning">
                            {{ 'USERS.SINGLE.TABS3.MAINTENANCE' | translate }}
                          </div>
                        }
                        @if (isBusyUpdatePwd) {
                          <div
                            class="general-container"
                            fxLayout="column"
                            fxLayoutAlign="center center">
                            <mat-progress-spinner
                              [color]="spinner.color"
                              [mode]="spinner.mode"
                              [value]="spinner.value"
                              [diameter]="spinner.diameter">
                            </mat-progress-spinner>
                            <div>{{ 'GENERAL.LOADING' | translate }}</div>
                          </div>
                        }
                        @if (isErrorUpdatePwd) {
                          <div class="general-container">
                            <div class="message-box error">
                              <app-error-message
                                [error]="errorUpdatePwd.error" />
                            </div>
                          </div>
                        }
                        @if (isPwdUpdated) {
                          <div class="general-container">
                            <div class="message-box success">
                              {{ 'SECURITY.FORM.SUCCESS' | translate }}
                            </div>
                          </div>
                        }
                      </form>
                    }
                  </mat-card>
                </div>
              </div>
            </mat-tab>
            @if (hasGoodRole()) {
              <mat-tab [label]="'USERUPDATE.ID-UPDATE' | translate">
                <div
                  class="content user-name-update"
                  fxLayout="row wrap"
                  fxLayout.sm="column-reverse wrap"
                  fxLayout.xs="column-reverse wrap">
                  <div
                    fxLayout="column"
                    fxFlex="70"
                    fxFlex.md="70"
                    fxFlex.sm="100"
                    fxFlex.xs="100"
                    fxLayout="column">
                    <mat-card class="security-card">
                      <h2>{{ 'USERUPDATE.TITLE-UPDATE' | translate }}</h2>
                      @if (isErrorGetUsers) {
                        <div class="message-box error">
                          <app-error-message [error]="errorGetUsers.error" />
                        </div>
                      }
                      @if (
                        selectedUser.lifeCycleState !== 'active' &&
                        isErrorGetUsers === false
                      ) {
                        <div class="message-box alert">
                          {{ 'USERS.SINGLE.TABS3.NOTACTIVATED' | translate }}
                        </div>
                      }
                      @if (isErrorGetAVS) {
                        <div class="message-box error">
                          <app-error-message [error]="errorGetAvs.error" />
                        </div>
                      }
                      <div
                        class="user-button-container"
                        fxLayout="row"
                        fxLayoutAlign="left left">
                        <button
                          class="left-button"
                          mat-raised-button
                          type="button"
                          color="accent"
                          (click)="verifyUpiInfo()">
                          {{ 'USERUPDATE.VERIFY-INFO' | translate }}
                        </button>
                        <button
                          class="left-button"
                          mat-raised-button
                          type="button"
                          color="primary  "
                          (click)="modifyAVS()">
                          {{ 'USERUPDATE.AVS-UPDATE' | translate }}
                        </button>
                        @if (hasChanges) {
                          <button
                            mat-raised-button
                            type="button"
                            color="warn"
                            (click)="defaultValue()">
                            {{ 'GENERAL.CANCEL' | translate }}
                          </button>
                        }
                        @if (isBusyVerifyAvs) {
                          <mat-progress-spinner
                            [color]="spinnerUpdateUser.color"
                            [mode]="spinnerUpdateUser.mode"
                            [value]="spinnerUpdateUser.value"
                            [diameter]="spinnerUpdateUser.diameter">
                          </mat-progress-spinner>
                        }
                      </div>
                      @if (hasNotChanges) {
                        <div class="message-box success info-correct">
                          {{ 'USERUPDATE.VERIFY-DATA' | translate }}
                        </div>
                      }
                      <div fxLayout="column">
                        <div
                          fxLayout="row"
                          class="form-container"
                          fxLayoutAlign="space-between">
                          <mat-card
                            class="info-avs"
                            fxFlex="100"
                            fxFlex.sm="100"
                            fxFlex.xs="100">
                            <h2 class="form-title">
                              {{ 'USER.ACTUAL-INFO' | translate }}
                            </h2>
                            @if (selectedUser.lifeCycleState === 'active') {
                              <form fxLayout="column" [formGroup]="upiInfoForm">
                                <div fxLayout="row" fxLayoutAlign="start start">
                                  <mat-form-field fxFlex appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.AVS' | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="avs" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.OFFICIALFIRSTNAME'
                                        | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="officialFirstName" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.OFFICIALLASTNAME'
                                        | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="officialLastName" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.FIRSTNAME' | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="firstName" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.LASTNAME' | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="lastName" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USER.EMAIL' | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="eduvsMail" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USER.LOGIN' | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="eduvsLogin" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.DATEOFBIRTH'
                                        | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="dateOfBirth" />
                                  </mat-form-field>
                                </div>
                                <div fxFlex="2 0 auto" fxLayout="row">
                                  <mat-form-field
                                    class="field-gender"
                                    fxFlex="100"
                                    appearance="outline">
                                    <mat-label>{{
                                      'USERS.SINGLE.INFO.GENDER' | translate
                                    }}</mat-label>
                                    <input
                                      autoComplete="on"
                                      matInput
                                      formControlName="gender" />
                                  </mat-form-field>
                                </div>
                              </form>
                            }
                          </mat-card>
                          @if (hasChanges || canChangeName) {
                            <div fxLayout="column" fxLayoutAlign="space-around">
                              <mat-icon class="update-arrow"
                                >arrow_forward</mat-icon
                              >
                            </div>
                            <mat-card
                              class="info-avs"
                              fxFlex="100"
                              fxFlex.sm="100"
                              fxFlex.xs="100">
                              <h2 class="form-title">
                                {{ 'USER.NEW-INFO' | translate }}
                              </h2>
                              @if (selectedUser.lifeCycleState === 'active') {
                                <form
                                  fxLayout="column"
                                  [formGroup]="updateform">
                                  <div
                                    fxLayout="row"
                                    fxLayoutAlign="start start">
                                    <mat-form-field fxFlex appearance="outline">
                                      <mat-label
                                        [ngClass]="{ 'red-text': avsMatched }"
                                        >{{
                                          'USERS.SINGLE.INFO.AVS' | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="avs"
                                        [ngClass]="{
                                          'red-text': avsMatched,
                                        }" />
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{
                                          'red-text': officialFirstNameMatched,
                                        }"
                                        >{{
                                          'USERS.SINGLE.INFO.OFFICIALFIRSTNAME'
                                            | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="officialFirstName"
                                        [ngClass]="{
                                          'red-text': officialFirstNameMatched,
                                        }" />
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{
                                          'red-text': officialLastNameMatched,
                                        }"
                                        >{{
                                          'USERS.SINGLE.INFO.OFFICIALLASTNAME'
                                            | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="officialLastName"
                                        [ngClass]="{
                                          'red-text': officialLastNameMatched,
                                        }" />
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{
                                          'red-text':
                                            firstNameMatched &&
                                            !this.updateform.get('firstName')
                                              .enabled,
                                        }"
                                        >{{
                                          'USERS.SINGLE.INFO.FIRSTNAME'
                                            | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        (input)="updateUserLoginForm()"
                                        [ngClass]="{
                                          'red-text':
                                            firstNameMatched &&
                                            !this.updateform.get('firstName')
                                              .enabled,
                                        }"
                                        formControlName="firstName" />
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{
                                          'red-text':
                                            lastNameMatched &&
                                            !this.updateform.get('lastName')
                                              .enabled,
                                        }"
                                        >{{
                                          'USERS.SINGLE.INFO.LASTNAME'
                                            | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        (input)="updateUserLoginForm()"
                                        [ngClass]="{
                                          'red-text':
                                            lastNameMatched &&
                                            !this.updateform.get('lastName')
                                              .enabled,
                                        }"
                                        formControlName="lastName" />
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{ 'red-text': emailMatched }"
                                        >{{
                                          'USER.NEW-EMAIL' | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="eduvsMail"
                                        [ngClass]="{
                                          'red-text': emailMatched,
                                        }" />
                                      <mat-icon
                                        matSuffix
                                        class="mat-icon-custom"
                                        matTooltip="{{
                                          'USER.EMAIL-TOOLTIP' | translate
                                        }}">
                                        help
                                      </mat-icon>
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{ 'red-text': loginMatched }"
                                        >{{
                                          'USER.NEW-LOGIN' | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="eduvsLogin"
                                        [ngClass]="{
                                          'red-text': loginMatched,
                                        }" />
                                      <mat-icon
                                        matSuffix
                                        class="mat-icon-custom"
                                        matTooltip="{{
                                          'USER.LOGIN-TOOLTIP' | translate
                                        }}">
                                        help
                                      </mat-icon>
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{
                                          'red-text': dateOfBirthMatched,
                                        }"
                                        >{{
                                          'USERS.SINGLE.INFO.DATEOFBIRTH'
                                            | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="dateOfBirth"
                                        [ngClass]="{
                                          'red-text': dateOfBirthMatched,
                                        }" />
                                    </mat-form-field>
                                  </div>
                                  <div fxFlex="2 0 auto" fxLayout="row">
                                    <mat-form-field
                                      class="field-gender"
                                      fxFlex="100"
                                      appearance="outline">
                                      <mat-label
                                        [ngClass]="{
                                          'red-text': genderMatched,
                                        }"
                                        >{{
                                          'USERS.SINGLE.INFO.GENDER' | translate
                                        }}</mat-label
                                      >
                                      <input
                                        autoComplete="on"
                                        matInput
                                        formControlName="gender"
                                        [ngClass]="{
                                          'red-text': genderMatched,
                                        }" />
                                    </mat-form-field>
                                  </div>
                                </form>
                              }
                            </mat-card>
                          }
                        </div>
                        <div
                          class="form-control"
                          fxLayout="column"
                          fxLayoutAlign="end end">
                          @if (updateform.errors?.['firstNameNotMatch']) {
                            <mat-error class="error-form">
                              {{ 'ERROR.FIRSTNAME' | translate }}
                            </mat-error>
                          }
                          @if (updateform.errors?.['lastNameNotMatch']) {
                            <mat-error class="error-form">
                              {{ 'ERROR.LASTNAME' | translate }}
                            </mat-error>
                          }
                          @if (updateform.errors?.['firstNameHasDuplicates']) {
                            <mat-error class="error-form">
                              {{ 'ERROR.FIRSTNAME_MULTIPLE' | translate }}
                            </mat-error>
                          }
                          @if (updateform.errors?.['lastNameHasDuplicates']) {
                            <mat-error class="error-form">
                              {{ 'ERROR.LASTNAME_MULTIPLE' | translate }}
                            </mat-error>
                          }
                          <div class="general-container" fxLayout="row">
                            <button
                              mat-raised-button
                              type="button"
                              color="accent"
                              (click)="avsUpdateValidation()"
                              [disabled]="
                                updateform.invalid ||
                                (!lastNameMatched &&
                                  !firstNameMatched &&
                                  !avsMatched &&
                                  !officialFirstNameMatched &&
                                  !officialLastNameMatched &&
                                  !dateOfBirthMatched &&
                                  !emailMatched &&
                                  !genderMatched &&
                                  !loginMatched)
                              ">
                              {{ 'USERUPDATE.VALIDATE' | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </mat-card>
                  </div>
                  <div
                    fxLayout="column"
                    fxFlex="30"
                    fxFlex.md="30"
                    fxFlex.sm="100"
                    fxFlex.xs="100"
                    fxLayout="column">
                    <mat-card class="security-card">
                      <h2>{{ 'USER.ACTIONS' | translate }}</h2>
                      <mat-accordion>
                        <mat-expansion-panel [expanded]="true">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <h4 class="desc-title">
                                {{ 'USER.VERIFICATION' | translate }}
                              </h4>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <h4 class="nobreak">
                            {{ 'USER.VERIFICATION-MESSAGE' | translate }}
                          </h4>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <h4 class="desc-title">
                                {{ 'USER.AVS' | translate }}
                              </h4>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <h4 class="nobreak">
                            {{ 'USER.AVS-MESSAGE' | translate }}
                            <ul>
                              <li>{{ 'USER.AVS-MODIFICATION' | translate }}</li>
                              <li>
                                {{ 'USER.AVS-OFFICIALLASTNAME' | translate }}
                              </li>
                              <li>{{ 'USER.AVS-DATE' | translate }}</li>
                            </ul>
                            {{ 'USER.AVS-CORRECT' | translate }}
                          </h4>
                        </mat-expansion-panel>
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <h4 class="desc-title">
                                {{ 'USER.SAVE' | translate }}
                              </h4>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <h4 class="nobreak">
                            {{ 'USER.SAVE-MESSAGE' | translate }}
                            <ul>
                              <li class="bold-text">
                                {{ 'USER.SAVE-TEACHER' | translate }}
                              </li>
                              {{
                                'USER.SAVE-TEACHER-MESSAGE' | translate
                              }}
                              <li class="bold-text">
                                {{ 'USER.SAVE-STUDENT' | translate }}
                              </li>
                              {{
                                'USER.SAVE-STUDENT-MESSAGE' | translate
                              }}
                            </ul>
                          </h4>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </mat-card>
                  </div>
                </div>
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
      <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
  </div>
</div>
